import { defaultRecommendations } from '@features/executive-report/domain/default-recommendations';
import { FormSchema } from './form-schema';
import { defaultObservations } from '@features/executive-report/domain/default-observations';
import { RslReport } from '@features/campaigns/subdomains/rsl';
import { sanitizeFormKey } from '@utils/form-keys';
import { validRslDimensionSlug } from './constants/dimensions';

export const defaultValues = (
  campaignName: string,
  report?: RslReport
): FormSchema => ({
  campaignName,
  teamMembers: [],
  salesObjectives: [
    {
      value:
        'Drive incremental sales and traffic through a multi-channel media approach.',
    },
    {
      value:
        'Identify best media audiences to reach our ideal customer target.',
    },
  ],
  salesDimensionRecommendations: {
    who: '',
    what: '',
    where: '',
  },
  footTrafficObjectives: [
    {
      value:
        'Drive incremental sales and traffic through a multi-channel media approach.',
    },
    {
      value:
        'Identify best media audiences to reach our ideal customer target.',
    },
  ],
  footTrafficDimensionRecommendations: {
    who: '',
    what: '',
    where: '',
  },
  subdimensionImagesByNameAndValue: report
    ? report.dimensions.reduce(
        (acc, dimension) => {
          const dimName = dimension.dimensionName;
          if (!validRslDimensionSlug(dimName)) return acc;
          if (typeof acc[dimName] !== 'object') {
            acc[dimName] = {};
          }
          (acc[dimName] as Record<string, unknown>)[
            sanitizeFormKey(dimension.dimensionValue)
          ] = null;
          return acc;
        },
        {} as FormSchema['subdimensionImagesByNameAndValue']
      )
    : {},
  recommendations: defaultRecommendations,
  observations: defaultObservations,
  includedSlides: {
    intro: {
      title: true,
      meetYourTeam: true,
      agenda: true,
      navigatingComplexity: true,
      incrementalityMatters: true,
    },
    sales: {
      cover: true,
      campaignOverview: true,
      campaignOverview2: true,
      who: true,
      what: true,
      where: true,
      optimizationSummary: true,
    },
    footTraffic: {
      cover: true,
      overview: true,
      who: true,
      what: true,
      where: true,
    },
    takeaways: {
      recommendations: true,
      discoverWhatsNext: true,
    },
  },
});
